var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
        'selfie-wrap': true,
        'right': _vm.isOwn
    }},[(_vm.msgInfo.type!=='lock')?[_c('img',{staticClass:"selfie",attrs:{"src":_vm.msgInfo.content,"alt":""}})]:_c('div',{staticClass:"lock",on:{"click":function($event){return _vm.handleUnlock(_vm.msgInfo)}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }